import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'

import HomeView from '../views/HomeView.vue'
import PostRoutes from './posts/index'
import PokemontcgRoutes from './pokemontcg'

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/experiences',
      name: 'experiences',
      // route level code-splitting
      // this generates a separate chunk (Experiences.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/ExperiencesView.vue')
    },
    {
      path: '/knowledge',
      name: 'knowledge',
      // route level code-splitting
      // this generates a separate chunk (Knowledge.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/KnowledgeView.vue')
    },
    ...PostRoutes,
    ...PokemontcgRoutes,
    {
      path: '/uses',
      name: 'uses',

      component: () => import('../views/UsesView.vue')
    },
    {
      path: '/project-dependencies',
      name: 'project-dependencies',

      component: () => import('../views/ProjectDependenciesView.vue')
    },
    { path: '/:pathMatch(.*)*', component: () => import('../views/404View.vue') }
  ]
})

router.afterEach((to, from) => {
  window?.dataLayer?.push({ event: 'Page View', to: to.fullPath })
})

export default router
